






































import { Wave } from '@/interfaces/Wave';
import { Component, Prop, Vue } from 'vue-property-decorator';
import SaveButton from '@/components/App/SaveButton.vue';
import axios from 'axios';
import env from '@/env';
import LanguageTextInput from '@/components/App/LanguageTextInput.vue';

@Component({
  components: { LanguageTextInput, SaveButton }
})
export default class WaveListItem extends Vue {
  @Prop()
  wave!: Wave;

  get waveLanguage() {
    const preferredLanguage = this.wave.waveLanguages?.find(
      (language: any) => language.languageId === this.$store.state.user.languageId
    );
    if (preferredLanguage) return preferredLanguage;
    return this.wave.waveLanguages?.[0];
  }

  get name() {
    return this.waveLanguage?.name;
  }

  async save() {
    const save = await axios.put(`${env.backend_url}/wave/${this.wave.id}`, this.wave);
    await this.$store.dispatch('refreshAllWaves');
    return save;
  }
}
